// DPDP Act 2023 consent + privacy constants
export const CONSENT_VERSION = 'v1.0 (Jun 2026)';

export const PRIVACY_CONTACT = {
  company: 'Rubicon Finservices',
  arn: 'ARN: 102867',
  address: '6A Dr. Rajendra Prasad Sarani, 4th Floor, R.No-20, Kolkata-700001',
  email: 'communications@rubiconfinservices.com',
  grievanceEmail: 'complaints@rubiconfinservices.com',
  phone: '+91-33-40442577',
  grievanceOfficer: 'Grievance Officer, Rubicon Finservices',
};

// Purpose statements shown in the consent notice at each collection point
export const CONSENT_PURPOSE = {
  risk_profile: 'assessing your investment risk tolerance and recommending suitable mutual fund schemes',
  onboarding: 'completing your KYC, account opening and onboarding for mutual fund investments',
  entity_onboarding: 'completing the entity KYC, account opening and onboarding for mutual fund investments',
  data_request: 'processing and responding to your data rights / grievance request',
};

// Build the consent audit object stored alongside each submission
export const buildConsent = (purpose, { assisted = false } = {}) => ({
  given: true,
  purpose,
  policy_version: CONSENT_VERSION,
  timestamp: new Date().toISOString(),
  method: assisted ? 'assisted-by-team' : 'self-fill',
});
